import { render } from "./AvatarImage.vue?vue&type=template&id=425de0f7&scoped=true"
import script from "./AvatarImage.vue?vue&type=script&lang=js"
export * from "./AvatarImage.vue?vue&type=script&lang=js"

import "./AvatarImage.vue?vue&type=style&index=0&id=425de0f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425de0f7"]])

export default __exports__